// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import { currencyConvertor } from '../../utils/currencyConvertorUtils';
import type { SelectConvertorMap } from '../../types/commonTypes';

type Props = {
  value: number,
  quantity?: string,
  cookies: Cookies,
  currenciesList: SelectConvertorMap,
  digits?: number,
}

function CurrencyConvertor({
  value, quantity = '', cookies, currenciesList, digits,
}: Props) {
  return (
    <div className="currency-convertor">
      {currencyConvertor(value, cookies, currenciesList, quantity, digits)}
    </div>
  );
}

export default withCookies(connect(state => ({
  currenciesList: state.dynamicKeys.currenciesList,
}))(CurrencyConvertor));
